import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext.jsx';
import { LocaleProvider } from './contexts/LocaleContext.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import Navbar from './components/Navbar.jsx';

import Landing from './pages/Landing.jsx';
import SignUp from './pages/SignUp.jsx';
import SignIn from './pages/SignIn.jsx';
import Onboarding from './pages/Onboarding.jsx';
import Feed from './pages/Feed.jsx';
import PostDetail from './pages/PostDetail.jsx';
import CaddieProfile from './pages/CaddieProfile.jsx';
import Upload from './pages/Upload.jsx';
import Messages from './pages/Messages.jsx';
import Conversation from './pages/Conversation.jsx';
import Caddies from './pages/Caddies.jsx';
import GolferProfile from './pages/GolferProfile.jsx';

export default function App() {
  return (
    <LocaleProvider>
      <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen flex flex-col">
          <Navbar />
          <main className="flex-1">
            <Routes>
              {/* Public */}
              <Route path="/" element={<Landing />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/signin" element={<SignIn />} />

              {/* Protected */}
              <Route element={<ProtectedRoute />}>
                <Route path="/onboarding" element={<Onboarding />} />
                <Route path="/feed" element={<Feed />} />
                <Route path="/caddies" element={<Caddies />} />
                <Route path="/posts/:id" element={<PostDetail />} />
                <Route path="/caddies/:id" element={<CaddieProfile />} />
                <Route path="/golfers/:id" element={<GolferProfile />} />
                <Route path="/upload" element={<Upload />} />
                <Route path="/messages" element={<Messages />} />
                <Route path="/messages/:userId" element={<Conversation />} />
              </Route>

              {/* Fallback */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
        </div>
      </BrowserRouter>
      </AuthProvider>
    </LocaleProvider>
  );
}
